"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.strategyMatrixReducer = exports.defaultStrategyMatrixState = void 0;
const Actions = __importStar(require("./actions"));
const constants_1 = require("../../store/shared/selected-l1-categories/constants");
const reducer_1 = require("../../store/shared/selected-l1-categories/reducer");
exports.defaultStrategyMatrixState = Object.assign({ selectedAttributes: [], selectedDisplayTable: [] }, reducer_1.defaultSelectedL1CategoriesState);
const strategyMatrixReducer = (
// eslint-disable-next-line default-param-last
state = exports.defaultStrategyMatrixState, action) => {
    if (action.type === Actions.SET_SELECTED_DATA_FOR_STRATEGY_MATRIX) {
        const a = action;
        return updateStrategyMatrixData(state, a.payload);
    }
    if (action.type.includes(constants_1.SelectedL1CategoriesEntityPrefix.StrategyMatrix)) {
        return (0, reducer_1.createSelectedL1CategoriesReducer)(constants_1.SelectedL1CategoriesEntityPrefix.StrategyMatrix, exports.defaultStrategyMatrixState)(state, action);
    }
    return state;
};
exports.strategyMatrixReducer = strategyMatrixReducer;
const updateStrategyMatrixData = (state, { changes }) => (Object.assign(Object.assign({}, state), changes));
